import { CommonModule } from '@angular/common';
import { Component,OnInit,inject,signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { CampaignService } from '../campaign-service/campaign-service';
import { listTemplate } from '../campaign-model/campaign-model';
import {provideNativeDateAdapter} from '@angular/material/core';
@Component({
  selector: 'app-manage-campaign',
  providers: [provideNativeDateAdapter()],
  imports: [
    MatFormFieldModule,
    MatIcon,
    MatPaginatorModule,
    MatCardModule,
    MatButtonModule,
    CommonModule,
    MatTableModule,
    PiasLayoutComponent
  ],
  templateUrl: './manage-campaign.component.html',
  styleUrl: './manage-campaign.component.scss'
})
export class ManageCampaignComponent implements OnInit {
private router = inject(Router);
private campaignService = inject(CampaignService);
isloading = true;
setSprinner = signal(false);

  ngOnInit(): void {
    this.fetchCampaigns();
  }
  
displayedColumns: string[] = ['name', 'channel', 'status', 'recipients', 'success', 'actions'];
dataSource = new MatTableDataSource<listTemplate>([]);

  async fetchCampaigns() {
    this.setSprinner = signal(true);
    
    await this.campaignService.listcampaign()
      .then((apiResponse: listTemplate[]) => {
        const sortedData = apiResponse.sort((a, b) => b.id - a.id);
        
        // Hand the sorted data to the table
        this.dataSource.data = sortedData;
        
        //  Pass the API array directly into the table's data property
       this.dataSource.data = apiResponse;
        
        this.setSprinner = signal(false);
      })
      .catch((error) => {
        console.error('Failed to load campaigns:', error);
        this.setSprinner = signal(false);
      });
  }
 

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
   clearSearch() {
    // this.searchQueryFg.get('searchApplicants')?.setValue('');
    // this.__applyAgentonboardFilter();
  }
   newCampaign(): void {
    this.router.navigate(['/campaign/create']);
  }
  onViewDetails(element: listTemplate) {
  // 'element' is already the exact "April Promo" data. 
  // We don't need to filter for ID #4, because we already have the whole object!
  
  this.router.navigate(['/campaign/detail'], { 
    state: { campaignData: element } // This puts the object into the Router's hidden "backpack"
  });
}
  // onViewDetails(): void {
  //   this.router.navigate(['/campaign/detail']);  
  // }
}

